export default {
  product_selection: {
    checkbox: "Should link to product or collection microsite?"
  }
}
